import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { CustomerBaseModel, CustomerModel } from '@libs/account/models';

@Component({
  selector: 'ui-order-addresses',
  templateUrl: './order-addresses.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
  ],
})
export class OrderAddressesComponent {
  public customer: InputSignal<CustomerModel> = input.required();

  public deliveryRecipient: Signal<CustomerBaseModel> = computed(() => {
    return this.customer().deliveryRecipient ?? this.customer();
  });

  public invoiceRecipient: Signal<CustomerBaseModel> = computed(() => {
    return this.customer().invoiceRecipient ?? this.customer();
  });

  public deliveryEqualsRecipientAddressee: Signal<boolean> = computed(() => {
    return this.deliveryRecipient().id === this.invoiceRecipient().id &&
      this.deliveryRecipient().name === this.invoiceRecipient().name &&
      this.deliveryRecipient().address?.streetAddress === this.invoiceRecipient().address?.streetAddress &&
      this.deliveryRecipient().address?.postalCode === this.invoiceRecipient().address?.postalCode &&
      this.deliveryRecipient().address?.locality === this.invoiceRecipient().address?.locality;
  });
}
